import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { Users, Calendar, Tag, Package, TrendingUp, Wallet, ClipboardList, User, LogOut, X, UserCog, ShoppingBag } from 'lucide-react';
import api from '../../api';

export default function BusinessLayout() {
  const [showMenu, setShowMenu] = useState(false);
  const [newApptCount, setNewApptCount] = useState(0);
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const isOwner = user?.user_type === 'owner';
  const isEmployee = user?.user_type === 'employee';
  const isVendedor = user?.business_type === 'Vendedor';
  const businessId = isEmployee ? user?.parent_user_id : user?.id;

  useEffect(() => {
    if (businessId && !isVendedor) {
      api.get(`/appointments/${businessId}/new-count`)
        .then(r => setNewApptCount(r.data.count || 0))
        .catch(() => {});
    }
  }, [businessId, isVendedor]);

  const handleLogout = () => { logout(); navigate('/'); };

  const menuItems = [
    { title: 'Clientes', icon: Users, route: '/business/clients' },
    isVendedor
      ? { title: 'Catálogo', icon: ShoppingBag, route: '/business/catalog' }
      : { title: 'Turnos', icon: Calendar, route: '/business/appointments', badge: newApptCount > 0 ? newApptCount : null },
    { title: 'Productos/Servicios', icon: Tag, route: '/business/products' },
    { title: 'Stock', icon: Package, route: '/business/stock' },
    { title: 'Ganancias', icon: TrendingUp, route: '/business/revenue' },
    { title: 'Gastos Varios', icon: Wallet, route: '/business/expenses' },
    { title: 'Cuenta Corriente', icon: ClipboardList, route: '/business/debts' },
    { title: 'Perfil', icon: User, route: '/business/profile' },
  ];

  if (isOwner) {
    menuItems.splice(7, 0, { title: 'Usuarios', icon: UserCog, route: '/business/users' });
  }

  return (
    <div className="app-container">
      <Outlet context={{ setShowMenu, setNewApptCount }} />

      {showMenu && (
        <div className="modal-overlay" style={{ justifyContent: 'flex-end' }} onClick={() => setShowMenu(false)}>
          <div className="menu-content" onClick={e => e.stopPropagation()}>
            <div className="menu-header">
              <h2>Menú</h2>
              <button className="icon-btn" onClick={() => setShowMenu(false)}><X size={24} /></button>
            </div>
            {menuItems.map((item, i) => (
              <button key={i} className="menu-item" data-testid={`menu-item-${item.title.toLowerCase().replace(/\s/g, '-')}`}
                onClick={() => { setShowMenu(false); navigate(item.route); }}>
                <span className="menu-item-icon"><item.icon size={22} strokeWidth={1.5} /></span>
                <span style={{ flex: 1 }}>{item.title}</span>
                {item.badge && (
                  <span style={{ background: 'var(--danger)', color: '#fff', borderRadius: '50%', width: 20, height: 20, fontSize: 11, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{item.badge}</span>
                )}
              </button>
            ))}
            <button className="menu-item menu-item-danger" onClick={() => { setShowMenu(false); handleLogout(); }}>
              <span className="menu-item-icon"><LogOut size={22} strokeWidth={1.5} /></span>
              <span>Cerrar Sesión</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
